import instanceAxios from "./intanceAxios";

export const locationsService = {
    postLocation: async (data) => await instanceAxios.post('/assets/location/', data),
    getLocations: async (filters) => await instanceAxios.get('/assets/location/', { params: filters }),
    putLocation: async (data) => await instanceAxios.put(`/assets/location/`, data),
    postMasiveLocations: async (data) => await instanceAxios.post('/assets/location-masive/', data),
    getLocationByHash: async (hash) => await instanceAxios.get(`/assets/location-hash/${hash}`),
    deleteLocation: async (ids) => await instanceAxios.delete(`/assets/location-delete/`, { data: { ids } }),
    getLocationsTree: async () => await instanceAxios.get('/assets/location-tree/')
}